import Timing from './Timing';

/**
 * Animates the window.scrollTo() with an easing function.
 *
 * Usage example:
 * ==============
 * let scroll = new Scroll();
 * scroll.to('.element', 1200, -30); // Scrolls to an element with the class 'element' within 1200 milliseconds and -30 pixels offset
 * scroll.top(0, 500);               // Scrolls to the top of the page (0px) within 500 milliseconds
 */
export default class Scroll {

	/**
	 * Constructor method.
	 */
	constructor() {
		this.animationFrame = null;

		window.addEventListener('mousewheel',     e => this.stop());
		window.addEventListener('DOMMouseScroll', e => this.stop());
		window.addEventListener('touchmove',      e => this.stop());
		window.addEventListener('touchstart',     e => this.stop());
	}

	/**
	 * Scrolls to the top of the provided element.
	 *
	 * @param  {string|element} el       Target element as scroll anchor
	 * @param  {number}         duration Scroll duration in milliseconds
	 * @param  {number}         offset   Scroll offset in pixels
	 * @return {bool}
	 */
	to(el, duration, offset) {
		this.el             = (typeof el === 'string') ? document.querySelector(el) : el;
		this.duration       = duration;
		this.offset         = (typeof offset === 'number') ? offset : 0;
		this.timing         = new Timing('easeInOutQuad', this.duration);
		this.start          = window.pageYOffset;
		this.marginTop      = parseInt(window.getComputedStyle(this.el, null).marginTop.replace('px', ''));
		this.diff           = Math.round(this.el.getBoundingClientRect().top - this.marginTop) + this.offset;
		this.end            = this.start + this.diff;

		this.stop();

		if (this.start != this.end) {
			this.animationFrame = requestAnimationFrame(timestamp => this.scroll(timestamp));
		}
	}

	/**
	 * Scrolls to a exact position from top in pixels.
	 *
	 * @param  {number} pos      Scroll position
	 * @param  {number} duration Scroll duration in milliseconds
	 * @return {undefined}
	 */
	top(pos, duration) {
		this.pos      = pos;
		this.duration = duration;
		this.timing   = new Timing('easeInOutQuad', this.duration);
		this.start    = window.pageYOffset;
		this.diff     = this.pos - this.start;
		this.end      = this.pos;

		this.stop();

		if (this.start != this.end) {
			this.animationFrame = requestAnimationFrame(timestamp => this.scroll(timestamp));
		}
	}

	/**
	 * Stops the current scroll animation.
	 *
	 * @return {undefined}
	 */
	stop() {
		cancelAnimationFrame(this.animationFrame);
	}

	/**
	 * Animates the scroll.
	 *
	 * @param  {number} timestamp Animation frame timestamp
	 * @return {undefined}
	 */
	scroll(timestamp) {
		this.timing.increase(timestamp);
		let pos = this.start + this.diff * this.timing.t;

		// Scroll
		window.scrollTo(0, pos);

		// Loop itself
		if (window.pageYOffset != this.end) {
			this.animationFrame = requestAnimationFrame(timestamp => this.scroll(timestamp));
		}
	}

}



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/library/Scroll.js